import { LoadingButton } from '@mui/lab'
import { useTransition } from 'react'
import { FragmentType, getFragmentData } from '../gql'
import { ExtractQueryRefHandlers } from '../util/apolloTypeUtils'
import { TopLosersTableFragment } from './TopLosersTable'
import { TopLosersLoader } from './topLosersLoader'

type FetchMoreType = ExtractQueryRefHandlers<TopLosersLoader>['fetchMore']

export function TopLosersLoadMoreButton({
  query,
  fetchMore
}: {
  query: FragmentType<typeof TopLosersTableFragment>
  fetchMore: FetchMoreType
}) {
  const [isLoading, startTransition] = useTransition()
  function handleFetchMore(args: Parameters<typeof fetchMore>[0]) {
    startTransition(() => {
      fetchMore(args)
    })
  }
  const { items, hasMore } = getFragmentData(TopLosersTableFragment, query)
  if (!hasMore) return null
  return (
    <LoadingButton
      loading={isLoading}
      onClick={(e) => {
        handleFetchMore({
          variables: {
            topLosersCursor: {
              balanceChange: items[items.length - 1].balanceChange,
              address: items[items.length - 1].address.address
            }
          }
        })
      }}
    >
      Load more
    </LoadingButton>
  )
}
